import { render, staticRenderFns } from "./BlogIndex.vue?vue&type=template&id=53af53d9&"
import script from "./BlogIndex.vue?vue&type=script&lang=js&"
export * from "./BlogIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlogIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports